export function operacaoVeiculoManutencaoUnidataInRequest(params = {}) {
  return {
    type: '@operacaoveiculomanutencaounidata/OPERACAOVEICULOMANUTENCAOUNIDATA_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoVeiculoManutencaoUnidata(veic_placa) {
  return {
    type: '@operacaoveiculomanutencaounidata/FIND_OPERACAOVEICULOMANUTENCAOUNIDATA',
    payload: { veic_placa },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoveiculomanutencaounidata/FAILED_REQUEST',
  };
}

export function deleteOperacaoVeiculoManutencaoUnidata(veic_placa, params) {
  return {
    type: '@operacaoveiculomanutencaounidata/DELETE_OPERACAOVEICULOMANUTENCAOUNIDATA',
    payload: { veic_placa, params },
  };
}

export function updateOperacaoVeiculoManutencaoUnidata(operacaoveiculomanutencaounidata, params) {
  return {
    type: '@operacaoveiculomanutencaounidata/UPDATE_OPERACAOVEICULOMANUTENCAOUNIDATA',
    payload: { operacaoveiculomanutencaounidata, params },
  };
}

export function storeOperacaoVeiculoManutencaoUnidata(operacaoveiculomanutencaounidata, params) {
  return {
    type: '@operacaoveiculomanutencaounidata/STORE_OPERACAOVEICULOMANUTENCAOUNIDATA',
    payload: { operacaoveiculomanutencaounidata, params },
  };
}

export function successInRequest(
  operacaoveiculomanutencaounidata,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoveiculomanutencaounidata/SUCCESS_IN_REQUEST',
    payload: {
      operacaoveiculomanutencaounidata,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
  };
}

export function successRequest(operacaoveiculomanutencaounidata) {
  return {
    type: '@operacaoveiculomanutencaounidata/SUCCESS_REQUEST',
    payload: { operacaoveiculomanutencaounidata },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoveiculomanutencaounidata/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoveiculomanutencaounidata/RECORD_FILTERING',
    payload: { params },
  };
}
